import { CityCeps } from "./cep-models";

var endpoint = window.location.hostname.match(/localhost/)  ? "/" : "/marketing/";

export async function searchCepByCity(city:string):Promise<CityCeps[]>{
    const res = await fetch(endpoint + "cities-cep?search=" + encodeURIComponent(city))
    return (await res.json()).result;
}